export const acceptServiceRequest = 'Accept service request?';
export const acceptDescription = 'If you accept this service request you are expected to complete it as soon as possible.';
export const accept = 'accept';
export const cancel = 'cancel';
export const acceptedSuccessMessage = 'Successfully accepted service request!';
